import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//Shared code with conversation-assistant-service/src/common/utils/fetch.ts

import { FetchError } from './fetch-error';
//TODO have this extend RovoInstrumentedError once that PR is merged
var HttpApiError = /*#__PURE__*/function (_Error) {
  function HttpApiError(message, errorAttributes) {
    var _this;
    _classCallCheck(this, HttpApiError);
    _this = _callSuper(this, HttpApiError, [message]);
    _this.message = message;
    _this.errorAttributes = errorAttributes;
    return _this;
  }
  _inherits(HttpApiError, _Error);
  return _createClass(HttpApiError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var performHttpFetch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var path, options, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          path = _ref.path, options = _ref.options;
          _context.prev = 1;
          _context.next = 4;
          return fetch(path, options);
        case 4:
          response = _context.sent;
          if (!(!response.ok || response.status >= 400)) {
            _context.next = 8;
            break;
          }
          _context.next = 8;
          return processHttpErrorResponse({
            response: response
          });
        case 8:
          _context.next = 10;
          return response.json();
        case 10:
          return _context.abrupt("return", _context.sent);
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
          throw new FetchError("performHttpFetch error whle fetching ".concat(path), {
            cause: _context.t0
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 13]]);
  }));
  return function performHttpFetch(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var processHttpErrorResponse = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          response = _ref3.response;
          _context2.t0 = HttpApiError;
          _context2.t1 = "[Code ".concat(response.status, "] ");
          _context2.next = 5;
          return response.text();
        case 5:
          _context2.t2 = _context2.sent;
          _context2.t3 = _context2.t1.concat.call(_context2.t1, _context2.t2);
          _context2.t4 = {
            statusCode: response.status
          };
          throw new _context2.t0(_context2.t3, _context2.t4);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function processHttpErrorResponse(_x2) {
    return _ref4.apply(this, arguments);
  };
}();